"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    border: none;\n    padding: 0;\n    outline: 0;\n    background-color: transparent;\n    transition: color 0.1s linear;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border-radius: 0;\n    cursor: pointer;\n    flex-direction: column;\n    box-sizing: border-box;\n    color: inherit;\n    font: inherit;\n    margin: 0;\n    overflow: visible;\n    text-transform: none;\n    appearance: button;\n\n    ::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButtonContent = _styledComponents["default"].button(_templateObject());

var _default = StyledButtonContent;
exports["default"] = _default;